import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    masterData: {
        locationList: [],
        statusList: [],
        newStatusList: [],
        travelDistanceList:[]
    },
    params: {
        "page": 0,
        "pageSize": 0,
        "sortOrder": "",
        "sortColumn": "",
        "distance": "",
        "locationId": "",
        "employerUniqueId": "",
        "status": [],
        "SearchText": "",
        "isSearchWithCrieteria": false,
        "positions": [],
        "certifications": [],
        "specialities": [],
        "emrehrSystem": [],
        "shifts": [],
        "education": [],
        "covid19Vaccinated": [],
        "jobTypeid": 0
    },
    error: false,
    errorMessage: null
}

export const candidateSearchSlice = createSlice({
    name: 'candidateSearchInfo',
    initialState,
    reducers: {
        setCandidateSearchInfo: (state, action) => {
            state.data = action.payload;
        },
        setMasterData: (state, action) => {
            if (action.payload.location) {
                state.masterData.locationList = action.payload.location;
                state.masterData.statusList = action.payload.status;
                state.masterData.newStatusList = action.payload.newstatus;
                state.masterData.travelDistanceList = action.payload.travelDistance;
            }
        },
        setError: (state, action) => {
            state.error = true;
            state.errorMessage = action.payload;
        },
        resetError: (state) => {
            state.error = false;
            state.errorMessage = null;
        },
        setParams: (state, action) => {
            state.params = action.payload;
        },
        resetParams: (state) => {
            state.params = {
                "page": 0,
                "pageSize": 0,
                "sortOrder": "",
                "sortColumn": "",
                "distance": "",
                "locationId": "",
                "employerUniqueId": "",
                "status": [],
                "SearchText": "",
                "isSearchWithCrieteria": false,
                "positions": [],
                "certifications": [],
                "specialities": [],
                "emrehrSystem": [],
                "shifts": [],
                "education": [],
                "covid19Vaccinated": [],
                "jobTypeid": 0
            };
        }
    }
});

export const { setCandidateSearchInfo, setMasterData, setError, resetError, setParams, resetParams } = candidateSearchSlice.actions;

export default candidateSearchSlice.reducer;